export default function() {
    console.log("kumadi accordion");
    const accordionButtons = document.querySelectorAll(
        ".midwinter-accordion-button"
    );

    Array.from(accordionButtons).forEach((button, index) => {
        // Add data attributes for targeting
        const accordionItem = button.closest('.midwinter-accordion-item');
        const collapseElement = accordionItem.querySelector('.midwinter-accordion-collapse');
        
        if (collapseElement) {
            // Generate unique ID if not exists
            if (!collapseElement.id) {
                collapseElement.id = `midwinter-collapse-${Date.now()}-${index}`;
            }
            
            // Set data attributes on button
            button.setAttribute('data-bs-target', `#${collapseElement.id}`);
            button.setAttribute('aria-controls', collapseElement.id);
            button.setAttribute('aria-expanded', 'false');
        }

        button.addEventListener("click", (e) => {
            console.log("kumadi accordion button clicked");
            e.preventDefault();
            
            // Get the target collapse element
            const targetId = button.getAttribute("data-bs-target");
            const targetCollapse = document.querySelector(targetId);
            
            if (!targetCollapse) return;
            
            // Get the parent accordion
            const parentAccordion = targetCollapse.closest(".midwinter-accordion");
            if (!parentAccordion) return;
            
            // Check if this item is already expanded
            const isExpanded = targetCollapse.classList.contains("show");
            
            if (!isExpanded) {
                // Close all other accordion items in the same parent
                const otherCollapses = parentAccordion.querySelectorAll(".midwinter-accordion-collapse.show");
                otherCollapses.forEach(collapse => {
                    if (collapse !== targetCollapse) {
                        collapse.classList.remove("show");
                        const otherButton = parentAccordion.querySelector(`[data-bs-target="#${collapse.id}"]`);
                        if (otherButton) {
                            otherButton.classList.add("collapsed");
                            otherButton.setAttribute("aria-expanded", "false");
                        }
                    }
                });
                
                // Expand this item
                targetCollapse.classList.add("show");
                button.classList.remove("collapsed");
                button.setAttribute("aria-expanded", "true");
                
                // Add smooth animation
                targetCollapse.style.height = "0px";
                targetCollapse.style.transition = "height 0.3s ease";
                targetCollapse.style.overflow = "hidden";
                
                setTimeout(() => {
                    targetCollapse.style.height = targetCollapse.scrollHeight + "px";
                }, 10);
                
                // Clean up height after animation
                targetCollapse.addEventListener("transitionend", function cleanup() {
                    targetCollapse.style.height = "";
                    targetCollapse.style.transition = "";
                    targetCollapse.style.overflow = "";
                    targetCollapse.removeEventListener("transitionend", cleanup);
                }, { once: true });
                
            } else {
                // Collapse this item
                targetCollapse.style.height = targetCollapse.scrollHeight + "px";
                targetCollapse.style.transition = "height 0.3s ease";
                targetCollapse.style.overflow = "hidden";
                
                setTimeout(() => {
                    targetCollapse.style.height = "0px";
                }, 10);
                
                targetCollapse.addEventListener("transitionend", function cleanup() {
                    targetCollapse.classList.remove("show");
                    targetCollapse.style.height = "";
                    targetCollapse.style.transition = "";
                    targetCollapse.style.overflow = "";
                    button.classList.add("collapsed");
                    button.setAttribute("aria-expanded", "false");
                    targetCollapse.removeEventListener("transitionend", cleanup);
                }, { once: true });
            }
        });
    });
}


// WEBPACK FOOTER //
// ./src/js/partials/accordion.js